import React, { useState } from "react";

const RATING_LABELS = {
  1: "Not useful",
  2: "Marginal",
  3: "Useful",
  4: "Valuable",
  5: "Essential",
};

/**
 * 5-oval rating strip.
 * compact=true → small pill row (for cards)
 * compact=false → larger pills + label (for workbench)
 */
export default function RatingOvals({ value, onChange, compact = true, disabled = false }) {
  const [hover, setHover] = useState(null);
  const active = hover ?? value ?? 0;

  const fillClass  = "bg-slate-700 border-transparent";
  const emptyClass = "border-slate-200 bg-transparent";

  const size = compact
    ? "w-6 h-3 rounded-full"
    : "w-8 h-4 rounded-full";

  return (
    <div
      className="inline-flex items-center gap-1"
      title={value ? `${RATING_LABELS[value]} (${value}/5)` : "Rate this signal"}
    >
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          disabled={disabled}
          onMouseEnter={() => !disabled && setHover(i)}
          onMouseLeave={() => !disabled && setHover(null)}
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled) onChange(i === value ? null : i);
          }}
          className={`
            ${size} border transition-all duration-100
            ${active >= i ? fillClass : emptyClass}
            ${disabled ? "cursor-default" : "cursor-pointer hover:scale-110"}
          `}
        />
      ))}
      {!compact && (
        <span className="ml-2 text-[12px] text-slate-500 min-w-[70px]">
          {hover
            ? RATING_LABELS[hover]
            : value
            ? RATING_LABELS[value]
            : "Not rated"}
        </span>
      )}
    </div>
  );
}
